import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
const sSubLotLPGainControllerEndpoint = 'NegotiationSubLotLPGain';


export class NegotiationSubLotLPGainAPI {

  getSubLotLPGainByL2Id(L2Id) {
    return axios.get(getBackendURL() + sSubLotLPGainControllerEndpoint + '/GetLPGainListByL2Id?L2Id=' + L2Id);
  }

  createSubLotLPGain(l2LPGainDTO) {
    return axios.post(getBackendURL() + sSubLotLPGainControllerEndpoint + '/CreateLPGain', l2LPGainDTO);
  }

  updateSubLotLPGain(l2LPGainDTO) {
    return axios.put(getBackendURL() + sSubLotLPGainControllerEndpoint + '/UpdateLPGain', l2LPGainDTO);
  }

  deleteSubLotLPGain(LPGainId) {
    return axios.delete(getBackendURL() + sSubLotLPGainControllerEndpoint + '/DeleteLPGain?LPGainId=' + LPGainId);
  }

}

export default NegotiationSubLotLPGainAPI


// WEBPACK FOOTER //
// ./src/API/NegotiationSubLotLPGainAPI.js